import React from 'react';
import { Box, Container, Typography, Link, Grid, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import EmailIcon from '@mui/icons-material/Email';
import { beehiveTheme } from '../../styles/beehiveTheme';
import wrootLogo from '../../assets/wroot-logo.png';

const FooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: beehiveTheme.primary.main,
  color: beehiveTheme.neutral.white,
  padding: theme.spacing(8, 0, 4),
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: beehiveTheme.neutral.lightGray,
  textDecoration: 'none',
  fontSize: '0.95rem',
  transition: 'color 0.2s ease',
  cursor: 'pointer',
  '&:hover': {
    color: beehiveTheme.accent.main,
  },
}));

const LogoImage = styled('img')(({ theme }) => ({
  height: '32px',
  width: 'auto',
  marginBottom: theme.spacing(2),
}));

export default function BeehiveFooter() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <FooterContainer>
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          {/* Brand Section */}
          <Grid item xs={12} md={5}>
            <LogoImage src={wrootLogo} alt="Wroot" />
            <Typography variant="body2" sx={{ color: beehiveTheme.neutral.lightGray, lineHeight: 1.8, mb: 3 }}>
              AI-powered beehive monitoring for early Varroa mite detection. Protecting bee colonies through 
              continuous, intelligent monitoring.
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <EmailIcon sx={{ fontSize: 20, color: beehiveTheme.accent.main }} />
              <FooterLink href="mailto:support@wrootapp.com">
                support@wrootapp.com
              </FooterLink>
            </Box>
          </Grid>

          {/* Navigation */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, fontSize: '1rem', mb: 2 }}>
              Navigate
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <FooterLink onClick={() => scrollToSection('hero')}>Home</FooterLink>
              <FooterLink onClick={() => scrollToSection('problem')}>Problem</FooterLink>
              <FooterLink onClick={() => scrollToSection('solution')}>Solution</FooterLink>
              <FooterLink onClick={() => scrollToSection('how-it-works')}>How It Works</FooterLink>
              <FooterLink onClick={() => scrollToSection('contact')}>Contact</FooterLink>
            </Box>
          </Grid>

        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />

        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          flexWrap: 'wrap', 
          gap: 2 
        }}>
          <Typography variant="body2" sx={{ color: beehiveTheme.neutral.gray, fontSize: '0.9rem' }}>
            © {currentYear} Wroot. Built for beekeepers.
          </Typography>
          <Typography variant="body2" sx={{ color: beehiveTheme.neutral.gray, fontSize: '0.9rem' }}>
            Early detection saves colonies
          </Typography>
        </Box>
      </Container>
    </FooterContainer>
  );
}
